import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

import { List, ListItemButton, Menu } from '@mui/material'
import { useEffect } from 'react'
import CopyIcon from '../../assets/icons/Copy.svg?react'
import QuoteIcon from '../../assets/icons/Quote.svg?react'
import {
    useTextSelectionMenuActions,
    useTextSelectionMenuStore,
} from '../../store/storeTextSelectionMenu'

export const TextSelectionMenu = () => {
    const anchor = useTextSelectionMenuStore((state) => state.anchor)
    const pos = useTextSelectionMenuStore((state) => state.pos)
    const { closeMenu, copyText, quoteText, quoteClear } = useTextSelectionMenuActions()

    const isOpen = !!anchor

    useEffect(() => {
        const handleChangeSelection = () => {
            const activeSelection = document.getSelection()
            const text = activeSelection?.toString()

            if (!activeSelection || !text) {
                closeMenu()
            }
        }

        document.addEventListener('click', handleChangeSelection)

        return () => {
            document.removeEventListener('click', handleChangeSelection)
            quoteClear()
            closeMenu()
        }
    }, [])

    return (
        <Menu
            disableEnforceFocus
            open={isOpen}
            autoFocus={false}
            anchorReference="anchorPosition"
            anchorPosition={{ top: pos.y, left: pos.x }}
            slotProps={{
                root: {
                    'aria-hidden': false,
                },
            }}>
            <List sx={{ p: 0.5, maxWidth: 173 }}>
                <ListItemButton
                    onClick={quoteText}
                    sx={{ color: 'inherit', p: '6px 16px', height: '36px' }}>
                    <ListItemText>Цитировать</ListItemText>
                    <ListItemIcon sx={{ justifyContent: 'flex-end', color: 'inherit' }}>
                        <QuoteIcon />
                    </ListItemIcon>
                </ListItemButton>
                <ListItemButton
                    onClick={copyText}
                    sx={{ color: 'inherit', p: '6px 16px', height: '36px' }}>
                    <ListItemText>Копировать</ListItemText>
                    <ListItemIcon sx={{ justifyContent: 'flex-end', color: 'inherit' }}>
                        <CopyIcon />
                    </ListItemIcon>
                </ListItemButton>
            </List>
        </Menu>
    )
}
